var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ykc-detail-item-box"},[_c('el-form-item',{ref:"ykcDetailItem",class:_vm.formItemClass,attrs:{"label":_vm.label,"label-width":_vm.labelWidth,"tagText":_vm.tagText}},[_vm._t("default"),(_vm.tagText)?_c('div',{staticClass:"tag",on:{"click":_vm.onTagClick}},[_vm._v(" "+_vm._s(_vm.tagText)+" ")]):_vm._e()],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }